import { Field, Form, Formik } from 'formik';
import { useRef } from 'react';
import { DatePickerField } from '../../../components/formFields/DatePickerField';
import { InputField } from '../../../components/formFields/InputField';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';
import * as Yup from 'yup';
import { validDate } from '../../../utils/time';
import Label from '@/components/Label';

interface DocDialogProps {
  visible: boolean;
  onClose: () => void;
  formProps: any;
  onSubmit: (id: any, values: any) => void;
}

const DocDialog: React.FC<DocDialogProps> = ({ visible, onClose, formProps, onSubmit }) => {
  const formRef = useRef<any>(null);

  const ValidationSchema = Yup.object().shape({
    title: Yup.string().nullable().required('Povinné pole'),
  });

  const onSubmitButton = () => {
    if (!formRef?.current) return null;
    formRef.current.submitForm();
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{formProps ? 'Editace dokumentace' : 'Vytvoření dokumentace'}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Formik
            innerRef={formRef}
            enableReinitialize={true}
            validationSchema={ValidationSchema}
            initialValues={{
              title: formProps?.title || null,
              publication_data: formProps?.publication_data || null,
              chief_engineer_name: formProps?.chief_engineer_name || null,
              builder_name: formProps?.builder_name || null,
            }}
            onSubmit={(values) => {
              onSubmit(formProps?.id, values);
            }}
          >
            {(props) => {
              const { values, setFieldValue } = props;
              return (
                <>
                  <Form className="space-y-1">
                    <div>
                      <Label name="title" title="Název" required />
                      <Field
                        name="title"
                        value={values.title || null}
                        placeholder="Název"
                        component={InputField}
                      />
                    </div>

                    <div>
                      <Label name="publication_data" title="Datum publikace" />
                      <Field
                        name="publication_data"
                        value={validDate(values.publication_data) || null}
                        onChange={(date: Date | null) => setFieldValue('publication_data', date)}
                        placeholder=""
                        component={DatePickerField}
                      />
                    </div>

                    <div>
                      <Label name="chief_engineer_name" title="Hlavní inženýr projektu" />
                      <Field
                        name="chief_engineer_name"
                        value={values.chief_engineer_name || null}
                        placeholder=""
                        component={InputField}
                      />
                    </div>

                    <div>
                      <Label name="builder_name" title="Stavebník" />
                      <Field
                        name="builder_name"
                        value={values.builder_name || null}
                        placeholder=""
                        component={InputField}
                      />
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="create-doc-dialog-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button
            key={2}
            data-testid="create-doc-dialog-confirm-btn"
            onClick={() => onSubmitButton()}
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DocDialog;
